import { render, staticRenderFns } from "./OptionEditSelectedIfTab.vue?vue&type=template&id=a1ce3ef0"
import script from "./OptionEditSelectedIfTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditSelectedIfTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports